import _APP from "config/app.config";

const determineVisiblePages = (activePageIndex, pages) => {
  let pageIndices = pages.map((page) => page.index);
  let newModel = {
    visiblePages: [],
    preceeding: false,
    successive: false,
    activePageIndex,
  };

  if (pages.length <= _APP.search.pagesToShow) {
    newModel.visiblePages = pageIndices;
  } else {
    let pagesBeforeToShow = Math.floor((_APP.search.pagesToShow - 1) / 2);
    let pagesBefore = activePageIndex <= 1 ? [] : pageIndices.slice(0, activePageIndex - 1);
    let pagesAfterToShow = Math.ceil((_APP.search.pagesToShow - 1) / 2);
    let pagesAfter =
      activePageIndex >= pageIndices.length ? [] : pageIndices.slice(activePageIndex, pageIndices.length);

    newModel.preceeding = pagesBefore.length >= pagesBeforeToShow;
    for (let i = 0; i < (pagesBefore.length < pagesBeforeToShow ? pagesBefore.length : pagesBeforeToShow); i++) {
      newModel.visiblePages.unshift(pagesBefore.pop());
    }

    newModel.visiblePages.push(activePageIndex);

    newModel.successive = pagesAfter.length >= pagesAfterToShow;
    for (let i = 0; i < (pagesAfter.length < pagesAfterToShow ? pagesAfter.length : pagesAfterToShow); i++) {
      newModel.visiblePages.push(pagesAfter.shift());
    }

    let remainder = _APP.search.pagesToShow - newModel.visiblePages.length;
    if (remainder) {
      if (newModel.preceeding) {
        for (let i = 0; i < remainder; i++) {
          newModel.visiblePages.unshift(pagesBefore.pop());
        }
      }
      if (newModel.successive) {
        for (let i = 0; i < remainder; i++) {
          newModel.visiblePages.push(pagesAfter.shift());
        }
      }
    }
  }

  if(newModel.visiblePages.length >= 5) {
    newModel.visiblePages = newModel.visiblePages.slice(0,5)
  }

  return newModel;
};

export default determineVisiblePages;
